'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _HubsToPath;

import AllowedHubs from './AllowedHubs';
var HubsToPath = (_HubsToPath = {}, _defineProperty(_HubsToPath, AllowedHubs.HUBS_CAMPAIGN, 'hubs_campaign'), _defineProperty(_HubsToPath, AllowedHubs.HUBS_CONTENT, 'hubs_content'), _defineProperty(_HubsToPath, AllowedHubs.HUBS_CTA, 'hubs_cta'), _defineProperty(_HubsToPath, AllowedHubs.HUBS_MEDIUM, 'hubs_medium'), _defineProperty(_HubsToPath, AllowedHubs.HUBS_SIGNUP_URL, 'hubs_signup-url'), _defineProperty(_HubsToPath, AllowedHubs.HUBS_SOURCE, 'hubs_source'), _HubsToPath);
export default HubsToPath;